import { api } from 'shared/api';

const _api = api.injectEndpoints({
  endpoints: (build) => ({
    deleteAccount: build.mutation({
      query: () => ({
        url: '/user/private/user-delete',
        method: 'DELETE',
      })
    })
  })
})

export const { useDeleteAccountMutation } = _api;
